import React from "react";
import { Input, Button, message } from "antd";
import request from "../../utils/request";
import GlobalParameters from "../../utils/globalParameters";
import "../../scss/mixin.css";

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: "",
      newPassword: "",
      repeatedNewPassword: "",
      passwordRules: {
        length: false,
        uppercase: false,
        number: false,
        special: false,
      },
    };
  }

  validatePassword = (password) => {
    this.setState({
      passwordRules: {
        length: password.length >= 8,
        uppercase: /[A-Z]/.test(password),
        number: /\d/.test(password),
        special: /[!@#$%^&*]/.test(password),
      },
    });
  };

  passwordsMatch = () => {
    const { newPassword, repeatedNewPassword } = this.state;
    return (
      repeatedNewPassword.length > 0 && newPassword === repeatedNewPassword
    );
  };

  render() {
    const { passwordRules, repeatedNewPassword } = this.state;

    const isPasswordValid = Object.values(passwordRules).every(Boolean);
    const showMatchMessage = repeatedNewPassword.length > 0;

    return (
      <div>
        <div className="marginTop" />

        <div className="container">
          <div className="panel panel-success">
            <div className="panel-heading">
              <h3 className="panel-title">Reset Password</h3>
            </div>

            <div className="panel-body">
              {/* Old Password */}
              <div className="row">
                <div className="col-md-8 col-md-offset-2">
                  <span>Old password</span>
                </div>
              </div>
              <div className="marginTop5" />
              <div className="row">
                <div className="col-md-8 col-md-offset-2">
                  <Input.Password
                    style={{ width: "99%" }}
                    onChange={(e) =>
                      this.setState({ oldPassword: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="marginTop10" />

              {/* New Password */}
              <div className="row">
                <div className="col-md-8 col-md-offset-2">
                  <span>New password</span>
                </div>
              </div>
              <div className="marginTop5" />
              <div className="row">
                <div className="col-md-8 col-md-offset-2">
                  <Input.Password
                    style={{ width: "99%" }}
                    onChange={(e) => {
                      const value = e.target.value;
                      this.setState({ newPassword: value });
                      this.validatePassword(value);
                    }}
                  />
                </div>
              </div>

              {/* Password Complexity */}
              <div className="row">
                <div
                  className="col-md-8 col-md-offset-2"
                  style={{ marginTop: 8, fontSize: 12 }}
                >
                  <div
                    style={{ color: passwordRules.length ? "green" : "red" }}
                  >
                    • At least 8 characters
                  </div>
                  <div
                    style={{ color: passwordRules.uppercase ? "green" : "red" }}
                  >
                    • One uppercase letter
                  </div>
                  <div
                    style={{ color: passwordRules.number ? "green" : "red" }}
                  >
                    • One number
                  </div>
                  <div
                    style={{ color: passwordRules.special ? "green" : "red" }}
                  >
                    • One special character (!@#$%^&*)
                  </div>
                </div>
              </div>

              <div className="marginTop10" />

              {/* Confirm Password */}
              <div className="row">
                <div className="col-md-8 col-md-offset-2">
                  <span>New password confirmation</span>
                </div>
              </div>
              <div className="marginTop5" />
              <div className="row">
                <div className="col-md-8 col-md-offset-2">
                  <Input.Password
                    style={{ width: "99%" }}
                    onChange={(e) =>
                      this.setState({
                        repeatedNewPassword: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              {/* Confirm Password Match */}
              {showMatchMessage && (
                <div className="row">
                  <div
                    className="col-md-8 col-md-offset-2"
                    style={{
                      marginTop: 6,
                      fontSize: 12,
                      color: this.passwordsMatch() ? "green" : "red",
                    }}
                  >
                    {this.passwordsMatch()
                      ? "✔ Passwords match"
                      : "✖ Passwords do not match"}
                  </div>
                </div>
              )}

              <div className="marginTop10" />

              {/* Submit */}
              <div className="row">
                <div className="col-md-8 col-md-offset-2">
                  <Button
                    type="primary"
                    disabled={!isPasswordValid || !this.passwordsMatch()}
                    onClick={() => {
                      const values = {
                        current_password: this.state.oldPassword,
                        password: this.state.newPassword,
                      };

                      request(
                        `${
                          GlobalParameters.website
                        }/erams/api/cportal/contacts/password_reset`,
                        {
                          method: "POST",
                          data: values,
                        },
                      ).then((response) => {
                        if (response.data[0] === "exception") {
                          message.error("It failed.");
                        } else {
                          message.success("Password reset successfully");
                        }
                      });
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPassword;
